import React, {useRef, useEffect, useState} from 'react';
import {Dimmer} from 'semantic-ui-react';

function Turnstile() {
  const turnstileRef = useRef(null);
  const [userToken, setUserToken] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.turnstile && turnstileRef.current) {
        clearInterval(interval);
        window.turnstile.render(turnstileRef.current, {
          'sitekey': process.env.REP_TURNSTILE_KEY,
          'callback': function(token) {
            setUserToken(token);
          },
        });
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <Dimmer active={process.env.REP_TURNSTILE_FLAG === 'enabled' && !userToken}>
      <div ref={turnstileRef}></div>
    </Dimmer>
  );
}

export default Turnstile;
